import AccountTypes from './AccountTypes';

export function loadData (queries) {
  return {
    type: AccountTypes.GET_ACCOUNT_SETTING_REQUEST,
    payload: queries
  };
}

export function loadDataError (tableName) {
  return {
    type: AccountTypes.GET_ACCOUNT_SETTING_ERROR,
    payload: tableName
  };
}

export function updateUserInfo (data) {
  return {
    type: AccountTypes.UPDATE_ACCOUNT_SETTING_REQUEST,
    payload: data
  };
}

export function resetUserPassword (data) {
  return {
    type: AccountTypes.RESET_USER_PASSWORD_REQUEST,
    payload: data
  };
}

export function changeUserPassword (data) {
  return {
    type: AccountTypes.CHANGE_PASSWORD_REQUEST,
    payload: data
  };
}

export function forgotPassword (data) {
  return {
    type: AccountTypes.FORGOT_PASSWORD_REQUEST,
    payload: data
  };
}

export function changeUserEmail (data) {
  return {
    type: AccountTypes.CHANGE_USER_EMAIL_REQUEST,
    payload: data
  };
}

export function setShowModal (data) {
  return {
    type: AccountTypes.SET_SHOW_MODAL,
    payload: data
  };
}

export function fetchAccountSettingDetail (data) {
  return {
    type: AccountTypes.GET_ACCOUNT_SETTING_DETAIL,
    payload: data
  };
}

export function updateAccountSettingDetail (data) {
  return {
    type: AccountTypes.UPDATE_ACCOUNT_SETTING_DETAIL,
    payload: data
  };
}

export function fetchPasswordRegex (data) {
  return {
    type: AccountTypes.GET_PASSWORD_REGEX,
    payload: data
  };
}

export function resetAllAccountSettings (data) {
  return {
    type: AccountTypes.RESET_ALL_ACCOUNT_SETTINGS,
    payload: data
  };
}
